// extracted by mini-css-extract-plugin
module.exports = {"profileName":"ofwcaProfilesTable_profileName__3GEbY"};